import { ParceriasCategorias } from 'src/app/core/parcerias-categorias';
import { CategoriasContabeis } from './categorias-contabeis';
export class AditivoParceriaCategoria {

	id:number;
	parceriasCategoria:ParceriasCategorias;
	dataAditivo:Date;
	valorAditivo:number;
}